import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=f8fa45dc&scoped=true&"
import script from "./Person.vue?vue&type=script&lang=js&"
export * from "./Person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fa45dc",
  null
  
)

export default component.exports